


























import Vue from "vue";
import { proxyModel } from "@/common/utils/proxyModel";
import { UserEditPasswordForm } from "../forms/UserEditPasswordForm";
export default Vue.extend({
  props: {
    value: {
      type: Object as () => UserEditPasswordForm
    },
    validations: {
      type: Object
    }
  },
  computed: {
    ...proxyModel("password", "confirmPassword"),
    passwordError() {
      return (this as any).validations.password.$error
        ? "Password must have at least 6 letters."
        : "";
    },
    confirmPasswordError() {
      return (this as any).validations.confirmPassword.$error
        ? "Passwords must be identical."
        : "";
    }
  }
});
